import { createContext, useContext, useMemo, useState } from "react";
import { makeT } from "@/lib/i18n";

const LangContext = createContext(null);

const KEY = "heritage_lang";

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const saved = typeof window !== "undefined" ? localStorage.getItem(KEY) : null;
    return saved === "ms" ? "ms" : "en";
  });

  const setLang = (l) => {
    localStorage.setItem(KEY, l);
    setLangState(l);
  };

  const t = useMemo(() => makeT(lang), [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>
  );
}

export const useI18n = () => useContext(LangContext);
